<template>
  <v-row justify="center" align="stretch" dense>
    <v-col cols="12" lg="4">
      <Lottie
        :podcast="true"
        data-aos="fade-up"
        data-aos-easing="ease"
        data-aos-duration="1000"
        data-aos-once="true"
      />
      <audio
        controls
        style="width: 100%; background-color: #f2f2f2; border-radius: 4px"
      >
        <source src="@/assets/modulo_02/podcasts/audio_1.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      <v-btn
        block
        color="primary"
        depressed
        class="white--text"
        @click="showTranscription = !showTranscription"
      >
        <div>Visualizar transcrição</div>
      </v-btn>
    </v-col>

    <v-col cols="12" lg="8" v-if="showTranscription" class="pt-0 pb-0 pr-0 pl-1">
      <TextBlock style="height: 100%;">
        <Paragraph
          class="px-8 py-7 rounded-lg"
          style="overflow: auto; height: 100%; background: white; color: #333;"
        >
        <strong>As marcas viárias</strong>  desempenham um papel crucial na organização e segurança do tráfego. Elas são pintadas diretamente na superfície da via e podem ser divididas em várias categorias, cada uma com uma função específica para orientar, regulamentar e informar os usuários das vias. Essas marcas ajudam a definir as regras de circulação, a promover a segurança e a garantir que o tráfego flua de maneira ordenada e eficiente.
        </Paragraph>
      </TextBlock>
    </v-col>
  </v-row>
</template>

<script>
import TextBlock from "@/components/TextBlock.vue";
import Paragraph from "@/components/Paragraph.vue";
import Lottie from "@/components/Lottie.vue";

export default {
  components: {
    TextBlock,
    Paragraph,
    Lottie,
  },
  data() {
    return {
      showTranscription: false,
    };
  },

  methods: {},
};
</script>

<style scoped></style>
